import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, NavLink, Input } from 'reactstrap';
import IconGoogleDrive from 'images/nav/google-drive.png';
import { canUpdateGoogleDriveDeleteLogic } from '../authorizations';

export default class GdriveFileDeletedModal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    const { currentAnimation, applyAllGdrive, defaultGdriveLogic } = this.props;
    const logicChanged = currentAnimation.additional_info['apply_all_gdrive'];
    const choice = currentAnimation.additional_info['handle_delete'] || defaultGdriveLogic
    this.state = {
      userChoice: choice,
      applyAllProject: (applyAllGdrive && logicChanged) || false,
      originalChoice: choice,
      applyOne: false,
      appliedAll: logicChanged
    }
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentAnimation !== this.props.currentAnimation) {
      const choice = nextProps?.currentAnimation.additional_info['handle_delete'] || nextProps?.defaultGdriveLogic
      this.setState({
        userChoice: choice,
        applyAllProject: (nextProps?.applyAllGdrive && nextProps?.currentAnimation.additional_info['apply_all_gdrive']) || false,
        originalChoice: choice,
        applyOne: false
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.props.onClickClose();
    }
  };
  handleChooseSubmit = (event) => {
    event.preventDefault();
    const { apiClient, onClickClose, onStart, endLoading, currentAnimation } = this.props;
    const { userChoice, applyAllProject } = this.state;
    onStart();
    const data = {
      handle_logic: userChoice,
      apply_logic: applyAllProject ? 'all' : 'one',
      animation_id: currentAnimation.id
    }
    return apiClient
      .post(
        `/update_gdrive_deletion_logic`,
        data
      )
      .then((_) => {
        if(applyAllProject) {
          location.reload();
        } else {
          this.setState({appliedAll: applyAllProject, originalChoice: userChoice})
          const event = new CustomEvent('gdriveFileDeletedModalLoaded', {'detail': userChoice});
          document.dispatchEvent(event);
          onClickClose();
          endLoading();
        }
      })
      .catch((_) => {
        Popup.alert("このページにアクセスできません。", '', '', {kind: 'akaire'});
        onClickClose();
        endLoading();
      })
  }

  setUserChoice = (choice) => {
    this.setState({userChoice: choice})
  }

  getUserChoiceText = (choice) => {
    if (choice === 'delete_all') {
      return '【全て削除】'
    } else if (choice === 'keep_comment') {
      return '【コメントのみ残す】'
    } else if (choice === 'keep_all') {
      return '【全て残す】'
    }
  }

  renderMobile() {
    const { isOpen, onClickClose, project, type, canUseApplyAll } = this.props;
    const { userChoice, applyAllProject, originalChoice, applyOne, appliedAll } = this.state;
    
    return (
      <Modal isOpen={isOpen} toggle={onClickClose} innerRef={node => (this.modalRef = node)} id='gdrive-file-deleted' className="animation-uploader-modal modal-dialog-centered modal-style additional-akaire mobile-view">
        <ModalBody className='text-center' style={{paddingTop: '10px'}}>
          <div className="modal-header align-items-center text-center d-flex justify-content-center" style={{paddingBottom: '6px'}}>
            <span className='additional-akaire-title'>
              <img className="icon-upload" src={IconGoogleDrive} alt="アップロード" width="40" />
              Googleドライブデータ削除時のアクション
            </span>
          </div>
          <div className='project-title mobile text-black'>「{project.name}」の、Googleドライブデータ削除時のアクションを変更します。</div>
          <div className='select-gdrive-logic'>
            <p className='mb-2'> 現在のデータ削除時のアクション：</p>
            <select 
              className='mobile drive_file_handling_logic w-100' 
              onChange={e => this.setUserChoice(e.target.value)} 
              defaultValue={userChoice}
              style={{
                postion: 'relative'
              }}
            >
              <option value='delete_all'>Googleドライブ側でデータを削除後、アカポンの全てのデータを削除</option>
              <option value='keep_comment'>Googleドライブ側でデータを削除後、アカポンのコメントのみ残す</option>
              <option value='keep_all'>Googleドライブ側でデータを削除後、アカポンの全てのデータを残す</option>
            </select>
          </div>
          <div className='d-flex justify-content-center align-items-center mt-3'>
            <div>
              {
                canUseApplyAll && (
                  <div className='d-flex align-items-center'>
                    <input className="check_input change_read_unread mobile" onChange={e => this.setState({applyAllProject: e.target.checked, applyOne: false})} checked={applyAllProject} type="checkbox"/>
                    <label className="check_label text-black mb-0">
                    全てのGoogleドライブデータ（動画およびPDFデータ）を、上記アクションに変更する。
                    {
                        appliedAll && (
                          <React.Fragment>
                            ※チェックを外すと解除されます。※現在、<span className="font-weight-bold text-red">{this.getUserChoiceText(originalChoice)}</span>に設定済み
                          </React.Fragment>
                        )
                    }
                    </label>
                  </div>
                )
              }

              <div className='d-flex align-items-center'>
                <input className="check_input change_read_unread mobile" onChange={e => this.setState({applyOne: e.target.checked, applyAllProject: false})} checked={applyOne} type="checkbox"/>
                <label className="check_label text-black mb-0">
                このファイルのGoogleドライブデータ（動画およびPDFデータ）だけ、上記アクションに変更する。※現在、<span className="font-weight-bold text-red">{this.getUserChoiceText(originalChoice)}</span>に設定済み
                </label>
              </div>
            </div>
          </div>
          <div className="text-center mt-3">
            <button type="button" className="w-120px btn btn-primary" disabled={!applyAllProject && !applyOne} onClick={(event) =>{this.handleChooseSubmit(event)}}>更新する</button>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  renderDesktop() {
    const { isOpen, onClickClose, project, type, canUseApplyAll } = this.props;
    const { userChoice, applyAllProject, originalChoice, applyOne, appliedAll } = this.state;
    
    return (
      <Modal isOpen={isOpen} toggle={onClickClose} innerRef={node => (this.modalRef = node)} id='gdrive-file-deleted' className="animation-uploader-modal modal-dialog-centered modal-style additional-akaire desktop-view">
        <ModalBody className='text-center'>
          <div className="modal-header align-items-center text-center d-flex justify-content-center">
            <span className='additional-akaire-title'>
              <img className="icon-upload" src={IconGoogleDrive} alt="アップロード" width="50" />
              Googleドライブデータ削除時のアクション
            </span>
          </div>
          <div className='project-title text-black'>「{project.name}」の、Googleドライブデータ削除時のアクションを変更します。</div>
          <div className='d-flex justify-content-center'>
            <div>
              <div className='select-gdrive-logic d-flex'>
                <p className='mb-auto'> 現在のデータ削除時のアクション：</p>
                <select className='drive_file_handling_logic' onChange={e => this.setUserChoice(e.target.value)} defaultValue={userChoice}>
                  <option value='delete_all'>【全て削除】Googleドライブ側でデータを削除後、アカポンの全てのデータを削除</option>
                  <option value='keep_comment'>【コメントのみ残す】Googleドライブ側でデータを削除後、アカポンのコメントのみ残す</option>
                  <option value='keep_all'>【全て残す】Googleドライブ側でデータを削除後、アカポンの全てのデータを残す</option>
                </select>
              </div>
              {
                canUseApplyAll && (
                  <div className='d-flex align-items-center mb-2'>
                    <input className="check_input change_read_unread" onChange={e => this.setState({applyAllProject: e.target.checked, applyOne: false})} checked={applyAllProject} type="checkbox"/>
                    <label className="check_label text-black mb-0">
                      全てのGoogleドライブデータ（動画およびPDFデータ）を、上記アクションに変更する。
                      {
                        appliedAll && (
                          <React.Fragment>
                            ※チェックを外すと解除されます。※現在、<span className="font-weight-bold text-red">{this.getUserChoiceText(originalChoice)}</span>に設定済み
                          </React.Fragment>
                        )
                      }
                    </label>
                  </div>
                )
              }
              <div className='d-flex align-items-center'>
                <input className="check_input change_read_unread" onChange={e => this.setState({applyOne: e.target.checked, applyAllProject: false})} checked={applyOne} type="checkbox"/>
                <label className="check_label text-black mb-0">
                  このファイルのGoogleドライブデータ（動画およびPDFデータ）だけ、上記アクションに変更する。※現在、<span className="font-weight-bold text-red">{this.getUserChoiceText(originalChoice)}</span>に設定済み
                </label>
              </div>
            </div>
          </div>
          <div className="text-center mt-3">
            <button type="button" className="w-120px btn btn-primary" disabled={!applyAllProject && !applyOne} onClick={(event) =>{this.handleChooseSubmit(event)}}>更新する</button>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    const isMobile = window.screen.width < 768;
    return isMobile ? this.renderMobile() : this.renderDesktop();
  }
};
